import React, { useEffect, useState } from "react"

import { Row, Col } from "reactstrap"

import Reviews from "./reviews"
import CreatePost from "./CreatePost"
import Notifications from "./notifications"
import Inbox from "./inbox"
import RecentActivity from "./recent-activity"
import WidgetUser from "./widget-user"
import { useSelector, useDispatch, connect } from "react-redux"
import YearlySales from "./yearly-sales"
import LatestTransactions from "./latest-transactions"
import LatestOrders from "./latest-orders"
import PostsList from "./posts_list"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"
import SnackbarComponent from "components/SnackBar"
import axios from "axios"
import PostDetails from "./PostDetails"
import Chat from "./chat"
import ReachChart from "./reach"
import ImpressionsChart from "./impressions"
import Miniwidgets from "pages/FacebookDashboard/MiniWidgets"
import config from "config/config"

const FacebookDashboard = props => {
  const [pageDetails, setPageDetails] = useState(null)
  const [err, setErr] = useState(null)
  const [viewMode, setViewMode] = useState("Month")
  const [success, setSuccess] = useState(null)
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [loadingInsights, setLoadingInsights] = useState(false)
  const [loadingReviews, setLoadingReviews] = useState(false)
  const [loadingPosts, setLoadingPosts] = useState(false)
  const [reviews, setReviews] = useState([])
  const [postClicked, setPostClicked] = useState(false)
  const [selectedPost, setSelectedPost] = useState(null)
  const [posts, setPosts] = useState([])
  const [period, setPeriod] = useState("day")
  const [reports, setReports] = useState([])
  const [nextPage, setNextPage] = useState(null)
  const [pageToken, setPageToken] = useState(null)

  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const userData = useSelector(state => state.Login.userData)
  document.title = "Dashboard | AeraVue"

  const breadcrumbItems = [
    {
      title: `${activeOrganization.name} (${activeOrganization.type})`,
      link: "/dashboard",
    },
    { title: "Facebook", link: "#" },
  ]

  const [syncing, setSyncing] = useState(false)
  const [syncKey, setSyncKey] = useState(0)

  const getOrganizationIds = () =>
    isConsolidatedView
      ? organizations.map(org => org.Organization.id)
      : [activeOrganization.id]

  const fetchInsights = async (force = false) => {
    try {
      setLoadingInsights(true)

      const params = {
        organizationIds: getOrganizationIds().join(","),
        viewMode,
        force,
      }
      if (viewMode === "Custom") {
        params.fromDate = fromDate
        params.toDate = toDate
      }

      const resp = await axios.get(
        `${config.backendUrl}/facebook/dashboard/insights`,
        {
          params,
          headers: { Authorization: `Bearer ${userData.token}` },
          skipLoader: true,
        },
      )

      setReports(resp.data.reports)
      setLoadingInsights(false)
    } catch (err) {
      console.log(err)
      setErr("Error Fetching Insights.")
      setLoadingInsights(false)
    }
  }

  const fetchReviews = async (force = false) => {
    setLoadingReviews(true)

    try {
      const resp = await axios.get(
        `${config.backendUrl}/facebook/dashboard/reviews`,
        {
          params: { organizationIds: getOrganizationIds().join(","), force },
          headers: { Authorization: `Bearer ${userData.token}` },
          skipLoader: true,
        },
      )

      setReviews(resp.data.reviews)
      setLoadingReviews(false)
    } catch (err) {
      console.log(err)
      setErr("Error Fetching reviews.")
      setLoadingReviews(false)
    }
  }

  const loadMorePosts = async () => {
    if (!nextPage) return // No more pages to load

    try {
      setLoadingPosts(true)
      const response = await axios.get(nextPage) // Use the next page URL
      console.log("More posts", response.data.data)

      setPosts(prevPosts => [...prevPosts, ...response.data.data]) // Append new posts
      setNextPage(response.data.paging?.next || null) // Update next page URL
      setLoadingPosts(false)
    } catch (err) {
      console.error("Error fetching more posts", err)
      setErr("Error loading more posts.")
    }
  }

  const fetchPosts = async (force = false) => {
    try {
      setLoadingPosts(true)

      const resp = await axios.get(
        `${config.backendUrl}/facebook/dashboard/posts`,
        {
          params: { organizationIds: getOrganizationIds().join(","), force },
          headers: { Authorization: `Bearer ${userData.token}` },
          skipLoader: true,
        },
      )

      setPosts(resp.data.posts)
      setLoadingPosts(false)
    } catch (err) {
      console.error("Fetch posts error:", err)
      setErr("Error fetching posts.")
      setLoadingPosts(false)
    }
  }

  const handleSync = async () => {
    setSyncing(true)
    setSyncKey(k => k + 1)
    try {
      await Promise.all([fetchInsights(true), fetchReviews(true), fetchPosts(true)])
    } finally {
      setSyncing(false)
    }
  }

  useEffect(() => {
    props.setBreadcrumbItems(`Facebook`, breadcrumbItems)
    fetchReviews()
    fetchPosts()
  }, [activeOrganization, isConsolidatedView, organizations])

  useEffect(() => {
    fetchInsights()
  }, [viewMode, activeOrganization, isConsolidatedView, organizations])

  return (
    <React.Fragment>
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      {postClicked ? (
        <PostDetails
          pageToken={pageToken}
          postId={selectedPost}
          setErr={setErr}
          setSuccess={setSuccess}
          setPostClicked={setPostClicked}
          setSelectedPost={setSelectedPost}
        />
      ) : (
        <>
          <Miniwidgets
            reports={reports}
            setViewMode={setViewMode}
            viewMode={viewMode}
            loading={loadingInsights}
            callBack={fetchInsights}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            onSync={handleSync}
            syncing={syncing}
          />
          <Row>
            <Col xl="6">
              {/* Monthly Earnings */}
              <ReachChart syncKey={syncKey} />
            </Col>

            <Col xl="6">
              {/* Email sent */}
              <ImpressionsChart syncKey={syncKey} />
            </Col>

            {/* <Col xl="3">
              <Notifications followersByCity={followersByCity} />
            </Col> */}
          </Row>
          <Row>
            <Col xl="12">
              {/* Monthly Earnings */}
              <Reviews reviews={reviews} loading={loadingReviews} />
            </Col>
            {/* <Col xl="3">
              <Notifications followersByCity={followersByCity} />
            </Col> */}
          </Row>
          <Row>
            <Col xl={12}>
              <PostsList
                reviews={posts}
                loading={loadingPosts}
                isConsolidatedView={isConsolidatedView}
                setPostClicked={setPostClicked}
                setSelectedPost={setSelectedPost}
                setPageToken={setPageToken}
              />
            </Col>
          </Row>
          {/* <Row>
            <Col xl="4" lg="6">
              <Inbox />
            </Col>
            <Col xl="4" lg="6">
              <RecentActivity />
            </Col>
            <Col xl="4">
              <WidgetUser />
              <YearlySales />
            </Col>
          </Row> */}
          {!isConsolidatedView && (
            <Row>
              <Col xl="12">
                <Chat setErr={setErr} />
              </Col>
            </Row>
          )}
        </>
      )}
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(FacebookDashboard)
